import { Component, OnInit } from '@angular/core';
import { Invite } from '@models/Core/Invite';
import { Session } from '@models/Sessions/Session';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from '@services/config.service';
import { SessionsRequestService } from '@services/sessions/sessions.request.service';
import { UserInviteService } from '@services/users/invite.service';

@Component({
  selector: 'app-invite-dialog',
  templateUrl: './invite-dialog.component.html',
  styleUrls: ['./invite-dialog.component.scss'],
})
export class InviteDialogComponent implements OnInit {
  storageKey = '--account-invite-form';

  sessions: {
    session: Session;
    role: number;
    selected: boolean;
  }[];
  invite: Invite;

  constructor(
    private service: UserInviteService,
    private sessionsService: SessionsRequestService,
    public activeModal: NgbActiveModal,
    public appConfig: ConfigService,
  ) {
    this.invite = {
      email: '',
      first_name: '',
      name: '',
      organization: '',
      message: '',
      sessions: [],
    };
  }

  ngOnInit() {
    this.sessionsService.getAll().subscribe(sessions => {
      this.sessions = sessions
        .filter(s => !s.config.restricted && s.me && s.me.can_invite)
        .map(s => ({
          session: s,
          role: Math.max(s.me.role, this.appConfig.roles.SESSION_PARTICIPANT),
          selected: !s.config.dont_invite_by_default,
        }));

      // this.load();
    });
  }

  store() {
    this.prepareInvite();
    localStorage.setItem(this.storageKey, JSON.stringify(this.invite));
  }

  load() {
    const candidate = localStorage.getItem(this.storageKey);
    if (candidate) {
      this.invite = JSON.parse(candidate);
      this.sessions.forEach(s => {
        const _candidate = this.invite.sessions.find(
          _s => _s.session === s.session._id.toString(),
        );
        if ((s.selected = !!_candidate)) {
          s.role = _candidate.role;
        }
      });
    }
  }

  clear() {
    localStorage.removeItem(this.storageKey);
  }

  dismiss() {
    this.activeModal.dismiss();
  }

  invalid() {
    return !this.invite.email || !this.invite.first_name || !this.invite.name;
  }

  selectableRoles(session: Session) {
    return this.appConfig.rolesSelectOptions.filter(
      role => role.value >= session.me.role,
    );
  }

  prepareInvite() {
    this.invite.email = this.invite.email.trim();
    this.invite.first_name = this.invite.first_name.trim();
    this.invite.name = this.invite.name.trim();
    this.invite.sessions = this.sessions
      .filter(s => s.selected)
      .map(s => ({ session: s.session._id, role: s.role }));
  }

  sendInvite() {
    this.prepareInvite();
    this.service.post(this.invite).subscribe(() => {
      this.activeModal.close(true);
      this.clear();
    });
  }
}
